// @ts-ignore
import { EventSourcePolyfill } from 'event-source-polyfill'
import localforage from 'localforage'
import posthog from 'posthog-js'
import { startTransition, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

import { configureGlobalCache } from '#app/utils/client-cache.ts'
import {
	detachUnexpectedDocumentChildren,
	installDomMutationGuards,
} from './utils/dom-mutation-guards.client.ts'
import { NonceProvider } from './utils/nonce-provider.ts'

if (window.ENV.MODE === 'production') {
	posthog.init('phc_kKfY8cBYrCStUumcilYiTe5KSoGy1CJW6EXuVQ0mRKM', {
		api_host: 'https://t.iuspro.com',
		defaults: '2026-01-30',
		person_profiles: 'always',
	})
}

// OR: may also need to set as global property
window.EventSource = EventSourcePolyfill
globalThis.EventSource = EventSourcePolyfill

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

installDomMutationGuards()
const restoreHostDocumentChildren = detachUnexpectedDocumentChildren(document)

function HydrationRoot() {
	useEffect(restoreHostDocumentChildren, [])
	return <HydratedRouter />
}

function isWordAuthenticationPage() {
	if (window.location.pathname === '/api/public/v1/word/auth') return true
	if (window.location.pathname !== '/login') return false
	return new URLSearchParams(window.location.search).get('redirectTo')?.startsWith('/api/public/v1/word/auth') ?? false
}

// Keep cached route snapshots across reloads with localforage's browser storage adapter.
configureGlobalCache(() => localforage)
const hydrate = () => {
	hydrateRoot(
		document,
		<NonceProvider value="">
			<HydrationRoot />
		</NonceProvider>,
	)
}

// Embedded Office hosts can mutate `<html>` during a deferred render. These
// small authentication pages must claim the server document immediately.
if (isWordAuthenticationPage()) hydrate()
else startTransition(hydrate)
